import { render, staticRenderFns } from "./DriverFinancialHistoric.vue?vue&type=template&id=48b67dd6"
import script from "./DriverFinancialHistoric.vue?vue&type=script&lang=js"
export * from "./DriverFinancialHistoric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports